<template>
    <div class="warehouse-remain">
        <CompassButton
            :label="$t.__('common.actions.delete')"
            type="primary-destructive"
            @click="openList"
        />
        <CompassButton
            :label="$t.__('stock.WarehouseRemain.edit')"
            type="primary"
            :onclick="`StockWareHouse.editOne('${warehouseId}')`"
            class="ml-2 mt-2"
        />

        <CompassDialog
            :visible.sync="showModal"
            size="large"
            :title="$t.__('stock.WarehouseRemain.remaining_product')"
            @before-close="handleClose"
        >
            <template #default>
                <div class="dialog__default">
                    <p class="grey typographies-paragraph-medium-regular">
                        {{
                            $l10n.__(
                                'Vous devez supprimer les stocks avant de pouvoir supprimer un entrepôt',
                            )
                        }}
                        <br />
                    </p>

                    <div v-if="loading" class="loader-container prelative mt-5">
                        <preloader :display="true" />
                    </div>
                    <div v-else class="form well well-no-shadow counter-customisation">
                        <el-table :data="items" style="width: 100%">
                            <el-table-column :label="$t.__('stock.WarehouseRemain.product')">
                                <template #default="scope">
                                    <a
                                        :href="`?_f=catalogueitem&id=${scope.row.itemid}&type=item&declid=${scope.row.declid}`"
                                    >
                                        {{ scope.row.name }}
                                    </a>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="qt"
                                :label="$t.__('stock.WarehouseRemain.stock_quantity')"
                            />
                            <el-table-column
                                prop="bookedqt"
                                :label="$t.__('stock.WarehouseRemain.reserved_quantity')"
                            />
                        </el-table>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="dialog__footer">
                    <CompassButton
                        :label="$t.__('common.actions.close')"
                        type="secondary"
                        @click="showModal = false"
                    />
                </div>
            </template>
        </CompassDialog>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    components: {
        Preloader,
    },
    props: {
        warehouseId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
            loading: false,
            items: [],
        };
    },

    methods: {
        openList() {
            this.showModal = true;

            this.getItems({ qt: 'gt:0' }).then(() => {
                // Search booked stock when no stock is found
                if (this.items.length == 0) {
                    this.getItems({ bookedqt: 'gt:0' });
                }
            });
        },
        handleClose() {
            this.showModal = false;
        },
        getItems(where) {
            this.loading = true;
            return new Promise((resolve) => {
                this.$ajax.get(`/rest/warehouse/${this.warehouseId}/items`, where, (data) => {
                    this.items = data.map((item) => {
                        item.link = `<a href="?_f=catalogueitem&id=${item.itemid}&type=item&declid=${item.declid}">${item.name}</a>`;
                        return item;
                    });
                    this.loading = false;
                    resolve();
                });
            });
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.warehouse-remain {
    display: flex;
    flex-direction: row;

    .dialog {
        &__default {
            padding-bottom: 24px;
            p {
                margin: 0 0 var(--spacing-3);
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}

.counter-customisation {
    .has-error input {
        border-color: $red;
    }
    .error-msg {
        color: $red;
    }
}
</style>
